export const NOISE_LIBRARY = {
  "128x128": [
    "Billow_01",
    "Billow_02",
    "Billow_03",
    "Billow_04",
    "DomainWarp_01",
    "DomainWarp_02",
    "DomainWarp_03",
    "DomainWarp_04",
    "FBM_01",
    "FBM_02",
    "FBM_03",
    "FBM_04",
    "Gaussian_01",
    "Gaussian_2",
    "Gaussian_3",
    "Gaussian_4",
    "Gaussian_5",
    "Impulse_01",
    "Impulse_2",
    "Impulse_3",
    "Impulse_4",
    "Impulse_5",
    "Laplacian_01",
    "Laplacian_2",
    "Laplacian_3",
    "Laplacian_4",
    "Laplacian_5",
    "LowFreq_1",
    "LowFreq_2",
    "LowFreq_3",
    "Multiplicative_01",
    "Multiplicative_2",
    "Multiplicative_3",
    "Multiplicative_4",
    "Multiplicative_5",
    "Perlin_01",
    "Perlin_02",
    "Perlin_03",
    "Perlin_04",
    "Perlin_05",
    "Perlin_06",
    "Perlin_07",
    "Perlin_08",
    "Perlin_09",
    "Perlin_10",
    "Perlin_11",
    "Perlin_12",
    "Perlin_13",
    "Perlin_14",
    "Perlin_15",
    "Perlin_16",
    "Perlin_17",
    "Perlin_18",
    "Perlin_19",
    "Perlin_20",
    "Perlin_21",
    "Perlin_22",
    "Perlin_23",
    "Perlin_24",
    "Plasma_01",
    "Plasma_2",
    "Plasma_3",
    "Plasma_4",
    "Plasma_5",
    "Poisson_01",
    "Poisson_2",
    "Poisson_3",
    "Poisson_4",
    "Poisson_5",
    "Random_01",
    "Random_2",
    "Random_3",
    "Random_4",
    "Random_5",
    "Ridged_01",
    "Ridged_02",
    "Ridged_03",
    "Ridged_04",
    "Simplex_01",
    "Simplex_02",
    "Simplex_03",
    "Simplex_04",
    "Turbulence_01",
    "Turbulence_02",
    "Turbulence_03",
    "Turbulence_04",
    "Uniform_01",
    "Uniform_2",
    "Uniform_3",
    "Uniform_4",
    "Uniform_5",
    "Value_01",
    "Value_02",
    "Value_03",
    "Value_04",
    "VoronoiEdge_01",
    "VoronoiEdge_02",
    "VoronoiEdge_03",
    "VoronoiEdge_04",
    "VoronoiF2_01",
    "VoronoiF2_02",
    "VoronoiF2_03",
    "VoronoiF2_04",
    "WhiteNoise_01",
    "WhiteNoise_02",
    "WhiteNoise_03",
    "WhiteNoise_04",
    "Worley_01",
    "Worley_02",
    "Worley_03",
    "Worley_04"
  ],
  "256x256": [
    "Billow_01",
    "Billow_02",
    "Billow_03",
    "Billow_04",
    "DomainWarp_01",
    "DomainWarp_02",
    "DomainWarp_03",
    "DomainWarp_04",
    "FBM_01",
    "FBM_02",
    "FBM_03",
    "FBM_04",
    "Gaussian_01",
    "Gaussian_2",
    "Gaussian_3",
    "Gaussian_4",
    "Gaussian_5",
    "Impulse_01",
    "Impulse_2",
    "Impulse_3",
    "Impulse_4",
    "Impulse_5",
    "Laplacian_01",
    "Laplacian_2",
    "Laplacian_3",
    "Laplacian_4",
    "Laplacian_5",
    "LowFreq_1",
    "LowFreq_2",
    "LowFreq_3",
    "Multiplicative_01",
    "Multiplicative_2",
    "Multiplicative_3",
    "Multiplicative_4",
    "Multiplicative_5",
    "Perlin_01",
    "Perlin_02",
    "Perlin_03",
    "Perlin_04",
    "Perlin_05",
    "Perlin_06",
    "Perlin_07",
    "Perlin_08",
    "Perlin_09",
    "Perlin_10",
    "Perlin_11",
    "Perlin_12",
    "Perlin_13",
    "Perlin_14",
    "Perlin_15",
    "Perlin_16",
    "Perlin_17",
    "Perlin_18",
    "Perlin_19",
    "Perlin_20",
    "Perlin_21",
    "Perlin_22",
    "Perlin_23",
    "Perlin_24",
    "Plasma_01",
    "Plasma_2",
    "Plasma_3",
    "Plasma_4",
    "Plasma_5",
    "Poisson_01",
    "Poisson_2",
    "Poisson_3",
    "Poisson_4",
    "Poisson_5",
    "Random_01",
    "Random_2",
    "Random_3",
    "Random_4",
    "Random_5",
    "Ridged_01",
    "Ridged_02",
    "Ridged_03",
    "Ridged_04",
    "Simplex_01",
    "Simplex_02",
    "Simplex_03",
    "Simplex_04",
    "Turbulence_01",
    "Turbulence_02",
    "Turbulence_03",
    "Turbulence_04",
    "Uniform_01",
    "Uniform_2",
    "Uniform_3",
    "Uniform_4",
    "Uniform_5",
    "Value_01",
    "Value_02",
    "Value_03",
    "Value_04",
    "VoronoiEdge_01",
    "VoronoiEdge_02",
    "VoronoiEdge_03",
    "VoronoiEdge_04",
    "VoronoiF2_01",
    "VoronoiF2_02",
    "VoronoiF2_03",
    "VoronoiF2_04",
    "WhiteNoise_01",
    "WhiteNoise_02",
    "WhiteNoise_03",
    "WhiteNoise_04",
    "Worley_01",
    "Worley_02",
    "Worley_03",
    "Worley_04"
  ],
  "512x512": [
    "Billow_01",
    "Billow_02",
    "Billow_03",
    "Billow_04",
    "DomainWarp_01",
    "DomainWarp_02",
    "DomainWarp_03",
    "DomainWarp_04",
    "FBM_01",
    "FBM_02",
    "FBM_03",
    "FBM_04",
    "Gaussian_01",
    "Gaussian_2",
    "Gaussian_3",
    "Gaussian_4",
    "Gaussian_5",
    "Impulse_01",
    "Impulse_2",
    "Impulse_3",
    "Impulse_4",
    "Impulse_5",
    "Laplacian_01",
    "Laplacian_2",
    "Laplacian_3",
    "Laplacian_4",
    "Laplacian_5",
    "LowFreq_1",
    "LowFreq_2",
    "LowFreq_3",
    "Multiplicative_01",
    "Multiplicative_2",
    "Multiplicative_3",
    "Multiplicative_4",
    "Multiplicative_5",
    "Perlin_01",
    "Perlin_02",
    "Perlin_03",
    "Perlin_04",
    "Perlin_05",
    "Perlin_06",
    "Perlin_07",
    "Perlin_08",
    "Perlin_09",
    "Perlin_10",
    "Perlin_11",
    "Perlin_12",
    "Perlin_13",
    "Perlin_14",
    "Perlin_15",
    "Perlin_16",
    "Perlin_17",
    "Perlin_18",
    "Perlin_19",
    "Perlin_20",
    "Perlin_21",
    "Perlin_22",
    "Perlin_23",
    "Perlin_24",
    "Plasma_01",
    "Plasma_2",
    "Plasma_3",
    "Plasma_4",
    "Plasma_5",
    "Poisson_01",
    "Poisson_2",
    "Poisson_3",
    "Poisson_4",
    "Poisson_5",
    "Random_01",
    "Random_2",
    "Random_3",
    "Random_4",
    "Random_5",
    "Ridged_01",
    "Ridged_02",
    "Ridged_03",
    "Ridged_04",
    "Simplex_01",
    "Simplex_02",
    "Simplex_03",
    "Simplex_04",
    "Turbulence_01",
    "Turbulence_02",
    "Turbulence_03",
    "Turbulence_04",
    "Uniform_01",
    "Uniform_2",
    "Uniform_3",
    "Uniform_4",
    "Uniform_5",
    "Value_01",
    "Value_02",
    "Value_03",
    "Value_04",
    "VoronoiEdge_01",
    "VoronoiEdge_02",
    "VoronoiEdge_03",
    "VoronoiEdge_04",
    "VoronoiF2_01",
    "VoronoiF2_02",
    "VoronoiF2_03",
    "VoronoiF2_04",
    "WhiteNoise_01",
    "WhiteNoise_02",
    "WhiteNoise_03",
    "WhiteNoise_04",
    "Worley_01",
    "Worley_02",
    "Worley_03",
    "Worley_04"
  ]
} as const;

export type NoiseResolution = keyof typeof NOISE_LIBRARY;

export const NOISE_DEFAULT = {
  res: "256x256",
  type: "Billow_01",
} as const;
